<template>
  <v-skeleton-loader
    v-if="loading"
    type="heading"
    width="150"
  />
  <div
    v-else
    :class="['user-status-count', { disabled: loading }]"
  >
    <span class="text-success active-user-text">
      {{ formatNumber(totals.totalActive || 0) }} Active
    </span>
    <span class="user-status-count-separator active-user-text">/</span>
    <span class="text-textDarkest active-user-text">
      {{ formatNumber(totals.totalInactive || 0) }} {{ inactiveLabel }}
    </span>
    <div
      v-if="datapeopleAnywhereEnabled && showDatapeopleAnywhereLine"
      class="text-textDarkest da-text"
    >
      {{
        formatNumber(totals.totalDatapeopleAnywhereInstalled || 0)
      }} Users have installed JobNav Anywhere
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { numberWithCommas } from '@/helpers/formatters';

defineProps({
  totals: { type: Object, default: () => ({}) },
  loading: { type: Boolean, default: false },
  showDatapeopleAnywhereLine: { type: Boolean, default: true },
  inactiveLabel: { type: String, default: 'Inactive' },
});

const { authData } = storeToRefs(useAppAuthData());

const datapeopleAnywhereEnabled = computed(() => authData.value.extensionJobsEnabled);

const formatNumber = (value) => numberWithCommas(value);
</script>

<style scoped lang="less">
.v-skeleton-loader {
  background: transparent;
}

:deep(.v-skeleton-loader__heading) {
  margin: 0;
}

.user-status-count {
  margin-right: 16px;
  font-weight: 400;
  text-align: left;
}

.user-status-count-separator {
  color: @grey-500;
  margin: 0 8px;
}

.active-user-text {
  font-size: 12px;
  line-height: 150%;
  font-weight: 500;
  color: @text-darkest;
}

.da-text {
  font-size: 12px;
  line-height: 150%;
  font-weight: 500;
  color: @text-dark;
}
</style>
